// src/router/gerencialProcessos.js

const breadCrumb = [
    /*
    {
        label: 'Home',
        to: 'Home'
    },
    */
    {
        label: 'Gerência de processos',
        to: 'GerencialProcessos'
    }
]

export default [
    {
        path: '/gerencia-processos',
        name: 'GerencialProcessos',
        component: () => import('@/views/GerencialProcessos/ProcessoListPage.vue'),
        meta: {
            title: 'Gerência de processos',
            breadcrumb: breadCrumb
        },
    },
    {
        path: '/gerencia-processos/novo',
        name: 'GerencialProcessoNovo',
        component: () => import('@/views/GerencialProcessos/NovoProcessoPage.vue'),
        meta: {
            title: 'Novo Gerencial Processo',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Gerencial Processo',
                    to: 'GerencialProcessoNovo'
                }
            ]
        }
    },
    {
        path: '/gerencia-processos/:id/detalhes',
        name: 'GerencialProcessoDetalhes',
        component: () => import('@/views/GerencialProcessos/NovoProcessoPage.vue'),
        meta: {
            title: 'Detalhes do Processo',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes',
                    
                }
            ]
        }
    },
    {
        path: '/gerencia-processos/:id/detalhe/container/:containerId',
        name: 'GerencialProcessoDetalhesContainer',
        component: () => import('@/views/GerencialProcessos/NovoProcessoPage.vue'),
        meta: {
            title: 'Detalhes do Processo',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes',
                    to: 'GerencialProcessoNovo'
                }
            ]
        }
    },
    {
        path: '/gerencia-processos/:id/detalhe/acompanhamentos',
        name: 'GerencialProcessoDetalhesAcompanhamentos',
        component: () => import('@/views/GerencialProcessos/NovoProcessoPage.vue'),
        meta: {
            title: 'Detalhes do Processo',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes',
                    to: 'GerencialProcessoNovo'
                }
            ]
        }
    }
];
